module.exports = __webpack_public_path__ + "img/05.7d9eab66.svg";